import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CONSTANTS from "../constants/constants";

export default function useDetailData() {
  const { storyId, draft } = useParams();
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(null);
  const [story, setStory] = useState(null);
  const [relatedStories, setRelatedStories] = useState([]);
  const [products, setProducts] = useState([]);
  const draftPath = draft === 'draft' ? 'draft/' : '';
  
  let customerId  = '';
  if (window.theme) {
    if (window.theme.customer) {
      customerId = window.theme.customer.id;
    }
  }
  else if (window.ogShopifyConfig) {
    if (window.ogShopifyConfig.customer) {
      customerId = window.ogShopifyConfig.customer.id;
    }
  }
  
  useEffect(() => {    
    setLoading(true);
    window.scroll(0,0);
    fetch(`${CONSTANTS.baseUrl}api/truestories/detail/${ draftPath }${ storyId }${draftPath != '' ? '/' + customerId : ''}`)
    .catch(err => setError(err))
    .then(res => res.json())
    .then(response => {
      setStory(response.data.trueStory)
      setRelatedStories(response.data.relatedStories);
      setProducts(response.data.trueStory.products);
      setLoading(false);
    });
  }, [ storyId ]);

  return [ loading, error, story, relatedStories, products ];
}
